module.exports = __webpack_public_path__ + "img/Published.60089ec5-p-500.0c2c31a6.png";